import React from 'react';
import { Segment, Icon, Grid, Input, Table, Button, Modal, Header } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import moment from 'moment';

const SegmentExampleStacked = ({
  orders,
  resultMessage,
  orderDetails,
  onSearchChange,
  onClickOfView,
  closeModal,
  onClickOfSearch,
  onClickOfBrowse
}) => (
  <Grid centered style={{ marginTop: '0px', padding: '10vh' }}>
    <Helmet>
      <title>Search Order Details</title>
    </Helmet>
    <Grid.Row centered>
      <Grid.Column width={4} textAlign="center">
        <h2
          style={{
            fontWeight: 400,
            border: '1px solid #555',
            textAlign: 'center',
            color: '#555',
            padding: '0.5em'
          }}
        >
          Search Order Details
        </h2>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={12}>
        <Modal size="large" open={orderDetails.openModal} closeIcon onClose={closeModal}>
          {orderDetails.loading ? (
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Segment style={{ height: '90vh' }} loading={orders.loading} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ) : null}
          <Modal.Header style={{ fontWeight: 400 }}>Expanded Details</Modal.Header>
          <Modal.Content>
            {orderDetails.data && orderDetails.data.order && orderDetails.data.order.length ? (
              <React.Fragment>
                <h3 style={{ fontWeight: 400, textDecoration: 'underline' }}>Order Details</h3>
                <Table celled striped fixed>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Order Id</Table.HeaderCell>
                      <Table.HeaderCell>Mobile</Table.HeaderCell>
                      <Table.HeaderCell>Amount</Table.HeaderCell>
                      <Table.HeaderCell>Status</Table.HeaderCell>
                      <Table.HeaderCell>VM Id</Table.HeaderCell>
                      <Table.HeaderCell>Payment Id</Table.HeaderCell>
                      <Table.HeaderCell>Source</Table.HeaderCell>
                      <Table.HeaderCell>Created On</Table.HeaderCell>
                      <Table.HeaderCell>Cashback</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {orderDetails.data &&
                      orderDetails.data.order &&
                      orderDetails.data.order.length &&
                      orderDetails.data.order.map(el => (
                        <Table.Row key={el.orderId}>
                          <Table.Cell style={{ wordWrap: 'break-word' }}>{el.orderId}</Table.Cell>
                          <Table.Cell>{el.orderMobile || 'N/A'}</Table.Cell>
                          <Table.Cell>Rs. {el.orderAmount}</Table.Cell>
                          <Table.Cell>{el.orderStatus}</Table.Cell>
                          <Table.Cell>{el.orderVM}</Table.Cell>
                          <Table.Cell>{el.orderPaymentId}</Table.Cell>
                          <Table.Cell>
                            {el.orderSource === 'vending' ? 'Kiosk App' : 'Consumer App'}
                          </Table.Cell>
                          <Table.Cell>
                            {/* {new Date(el.created_at).toLocaleString()} */}
                            {moment
                              .utc(el.orderCreatedAt)
                              .local()
                              .format('DD-MM-YYYY HH:mm:ss')}
                          </Table.Cell>
                          <Table.Cell>{el.orderCashback ? 'Yes' : 'No'}</Table.Cell>
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
              </React.Fragment>
            ) : null}
            {orderDetails.data &&
            orderDetails.data.orderLineItems &&
            orderDetails.data.orderLineItems.length ? (
              <React.Fragment>
                <h3 style={{ fontWeight: 400, textDecoration: 'underline' }}>Order Line Items</h3>

                <Table celled fixed>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Variant Name</Table.HeaderCell>
                      <Table.HeaderCell>Product Code[MV Id]</Table.HeaderCell>
                      <Table.HeaderCell>Item Quantity</Table.HeaderCell>
                      <Table.HeaderCell>Status</Table.HeaderCell>
                      <Table.HeaderCell>S/F/P Count</Table.HeaderCell>
                      <Table.HeaderCell>MRP</Table.HeaderCell>
                      <Table.HeaderCell>Offer Price</Table.HeaderCell>
                      <Table.HeaderCell>Slot Identifier</Table.HeaderCell>
                      <Table.HeaderCell>SKU Group Id</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {orderDetails.data &&
                      orderDetails.data.orderLineItems &&
                      orderDetails.data.orderLineItems.length &&
                      orderDetails.data.orderLineItems.map(el => (
                        <Table.Row key={el.oliId}>
                          <Table.Cell>{el.oliProductName}</Table.Cell>
                          <Table.Cell>{el.oliProductId}</Table.Cell>
                          <Table.Cell>{el.oliQunatity}</Table.Cell>
                          <Table.Cell>{`${el.oliStatus}`}</Table.Cell>
                          <Table.Cell>{`${el.oliS || 0}/${el.oliF || 0}/${el.oliP || 0}`}</Table.Cell>
                          <Table.Cell>Rs. {el.oliMRP}</Table.Cell>
                          <Table.Cell>Rs. {el.oliOfferPrice}</Table.Cell>
                          <Table.Cell>{el.oliSlotIndentifier}</Table.Cell>
                          <Table.Cell>{el.oliSKU}</Table.Cell>
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
              </React.Fragment>
            ) : null}
            {orderDetails.data &&
            orderDetails.data.paymentDetails &&
            orderDetails.data.paymentDetails.length ? (
              <React.Fragment>
                <h3 style={{ fontWeight: 400, textDecoration: 'underline' }}>Payment Details</h3>

                <Table celled fixed>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>ID</Table.HeaderCell>
                      <Table.HeaderCell>Payment Gateway</Table.HeaderCell>
                      <Table.HeaderCell>Payment Gateway ID</Table.HeaderCell>
                      <Table.HeaderCell>Cart ID</Table.HeaderCell>
                      <Table.HeaderCell>Amount</Table.HeaderCell>
                      <Table.HeaderCell>Status</Table.HeaderCell>
                      <Table.HeaderCell>Created On</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {orderDetails.data &&
                      orderDetails.data.paymentDetails &&
                      orderDetails.data.paymentDetails.length &&
                      orderDetails.data.paymentDetails.map(el => (
                        <Table.Row key={el.paymentId}>
                          <Table.Cell style={{ wordWrap: 'break-word' }}>{el.paymentId}</Table.Cell>
                          <Table.Cell>{el.paymentGateway}</Table.Cell>
                          <Table.Cell>{el.paymentGatewayId}</Table.Cell>
                          <Table.Cell>{el.paymentCartId}</Table.Cell>
                          <Table.Cell>Rs. {el.paymentAmount}</Table.Cell>
                          <Table.Cell>{el.paymentStatus}</Table.Cell>
                          <Table.Cell>
                            {moment
                              .utc(el.paymentCreatedOn)
                              .local()
                              .format('DD-MM-YYYY HH:mm:ss')}
                          </Table.Cell>
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
              </React.Fragment>
            ) : null}
            {orderDetails.data &&
            orderDetails.data.sysTxn &&
            orderDetails.data.sysTxn.length ? (
              <React.Fragment>
                <h3 style={{ fontWeight: 400, textDecoration: 'underline' }}>Transaction Details</h3>

                <Table celled fixed>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Payee ID</Table.HeaderCell>
                      <Table.HeaderCell>Payer ID</Table.HeaderCell>
                      <Table.HeaderCell>Payment Gateway ID</Table.HeaderCell>
                      <Table.HeaderCell>Status</Table.HeaderCell>
                      <Table.HeaderCell>Transaction Type</Table.HeaderCell>
                      <Table.HeaderCell>Created On</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {orderDetails.data &&
                      orderDetails.data.sysTxn &&
                      orderDetails.data.sysTxn.length &&
                      orderDetails.data.sysTxn.map(el => (
                        <Table.Row key={el.id}>
                          <Table.Cell>{el.payee_id || 'N/A'}</Table.Cell>
                          <Table.Cell>{el.payer_id || 'N/A'}</Table.Cell>
                          <Table.Cell>{el.payment_gateway_id}</Table.Cell>
                          <Table.Cell>{el.txn_message}</Table.Cell>
                          <Table.Cell style={{ wordWrap: 'break-word' }}>{el.txn_type}</Table.Cell>
                          <Table.Cell>
                            {moment
                              .utc(el.created_timestamp)
                              .local()
                              .format('DD-MM-YYYY HH:mm:ss')
                              }
                          </Table.Cell>
                        </Table.Row>
                      ))}
                  </Table.Body>
                </Table>
              </React.Fragment>
            ) : null}
          </Modal.Content>
        </Modal>
        <Segment stacked textAlign="center">
          <Grid>
            <Grid.Row centered>
              <Grid.Column textAlign="center" width={13}>
                <Input
                  fluid
                  icon
                  placeholder="Type mobile no./order id here..."
                  onChange={onSearchChange}
                  onKeyDown={onClickOfSearch}
                />
              </Grid.Column>
              <Grid.Column textAlign="center" width={3}>
                <Button
                  basic
                  color="blue"
                  fluid
                  data-actiontype="onClickOfSearch"
                  onClick={onClickOfSearch}
                  disabled={orders.loading}
                >
                  Search
                </Button>
              </Grid.Column>
            </Grid.Row>
            </Grid>
            {orders.loading || orders.list.length ? null : (
            <Grid centered textAlign="center">
            <Grid.Row centered>
            <Header as="h3"
                style={{
                  fontWeight: 400,
                  textAlign: 'center',
                  color: '#555',
                  padding: '0.5em'
                }}
              >
                  OR
                </Header>
            </Grid.Row>
            <Grid.Row centered>
              <Grid.Column textAlign="center" width={10} >
              <Header as="h3"
                style={{
                  fontWeight: 400,
                  textAlign: 'center',
                  color: '#555',
                  padding: '0.5em'
                }}
              >
                  Scan Your Screenshot
                </Header>
              </Grid.Column>
              <Grid.Column textAlign="center" width={5}>
                <Button
                  basic
                  color="blue"
                  fluid
                  data-actiontype="onClickOfBrowse"
                  onClick={onClickOfBrowse}
                  disabled={orders.loading}
                >
                  Browse
                </Button>
              </Grid.Column>
            </Grid.Row>
            </Grid>
          )}
          {orders.loading ? (
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <Segment style={{ height: '90vh' }} loading={orders.loading} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          ) : null}
          { resultMessage ?
            <span><br />{resultMessage}</span> : null
          }
          {orders.list.length ? (
            <React.Fragment>
              <br />
              <Table celled singleLine>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>No.</Table.HeaderCell>
                    <Table.HeaderCell>Order Id</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                    <Table.HeaderCell>Amount</Table.HeaderCell>
                    <Table.HeaderCell>Payment Id</Table.HeaderCell>
                    <Table.HeaderCell>Phone</Table.HeaderCell>
                    <Table.HeaderCell>Created On</Table.HeaderCell>
                    <Table.HeaderCell>Action(s)</Table.HeaderCell>
                    {/* <Table.HeaderCell>Action</Table.HeaderCell> */}
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {orders.list.length &&
                    orders.list.map((el, index) => (
                      <Table.Row key={el.id} negative={el.status === 'cancelled'}>
                        <Table.Cell>{index + 1}</Table.Cell>
                        <Table.Cell>{el.id}</Table.Cell>
                        <Table.Cell>{el.status}</Table.Cell>
                        <Table.Cell>{el.amount}</Table.Cell>
                        <Table.Cell>{el.payment_id}</Table.Cell>
                        <Table.Cell>{el.phone || 'N/A'}</Table.Cell>
                        <Table.Cell>
                          {moment
                            .utc(el.created_at)
                            .local()
                            .format('DD-MM-YYYY HH:mm:ss')}
                        </Table.Cell>
                        <Table.Cell>
                          <Button
                            basic
                            color="blue"
                            disabled={orderDetails.loading}
                            size="tiny"
                            onClick={() => onClickOfView(el.id)}
                          >
                            View Details
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))}
                </Table.Body>
              </Table>
            </React.Fragment>
          ) : null}
        </Segment>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

export default SegmentExampleStacked;



// WEBPACK FOOTER //
// ./src/Modules/OrderSearch/component.jsx